// 资讯分类。与后端 Post::CATEGORIES 一一对应，改动要同步 app/models/post.rb。
export const NEWS_CATEGORIES: Array<{ key: string; label: string }> = [
  { key: 'all', label: '全部' },
  { key: 'product', label: '产品更新' },
  { key: 'rules', label: '规则解读' },
  { key: 'event', label: '赛事动态' },
  { key: 'guide', label: '使用指南' },
  { key: 'other', label: '其他' },
]

export const newsCategoryLabel = (key?: string) =>
  NEWS_CATEGORIES.find((c) => c.key === key)?.label ?? '其他'

export type NewsItem = {
  id: string
  short_id?: string
  title: string
  cover?: string
  summary?: string
  category?: string
  tags?: string[]
  source?: string
  pinned?: boolean
  view_count?: number
  comment_count?: number
  published_at?: string
  created_at?: string
  owner_name?: string
}
